import React, { useEffect } from 'react';
import { loadScript } from './utils'; // Utility function to load Razorpay script
import { useNavigate } from 'react-router-dom';
import { doc, setDoc, addDoc, collection } from 'firebase/firestore'; // Added addDoc and collection
import { db } from '../firebase';

const PaymentButton = ({ amount, vNum, paymentType, hours, location }) => {
  const navigate = useNavigate();
  const RAZORPAY_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';

  // Load Razorpay script on component mount
  useEffect(() => {
    loadScript(RAZORPAY_SCRIPT);
  }, []);

  const handlePayment = async () => {
    try {
      // Call backend to create order
      const response = await fetch('https://number-plate-detection-three.vercel.app/create-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amount }), // Amount in rupees
      });

      if (!response.ok) {
        console.log(response);
        throw new Error('Failed to create order');
      }

      const { order_id, amount: order_amount, currency, key_id } = await response.json();

      // Initialize Razorpay payment
      const options = {
        key: key_id,
        amount: order_amount, // Amount in paise
        currency,
        name: 'MyEParking',
        description: 'Parking Fee Payment',
        order_id,
        handler: async (response) => {
          try {
            // Verify payment with backend
            const verifyResponse = await fetch('https://number-plate-detection-three.vercel.app/verify-payment', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }),
            });

            const verifyData = await verifyResponse.json();
            if (verifyData.status === 'success') {
              // Pass the payment ID to handlePostPayment
              handlePostPayment(response.razorpay_payment_id);
            } else {
              alert('Payment verification failed!');
            }
          } catch (err) {
            alert('Error verifying payment: ' + err.message);
          }
        },
        prefill: {
          name: 'Vehicle Owner',
          email: 'user@myeparking.web.app',
          contact: '9999999999',
        },
        theme: {
          color: '#3399cc',
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      alert('Error initiating payment: ' + err.message);
    }
  };

  const handlePostPayment = async (paymentId) => {
    try {
      let end;

      if (paymentType === "hourly") {
        end = new Date(Date.now() + hours * 60 * 60 * 1000);
      } else if (paymentType === "daily") {
        const today = new Date();
        today.setHours(23, 59, 59, 999);
        end = today;
      } else {
        const now = new Date();
        const monthlyEnd = new Date(now);
        monthlyEnd.setMonth(now.getMonth() + 1);
        monthlyEnd.setDate(monthlyEnd.getDate() - 1);
        monthlyEnd.setHours(23, 59, 59, 999);
        end = monthlyEnd;
      }

      const start = new Date();

      // Add payment record to "payments" collection with random ID
      await addDoc(collection(db, "payments"), {
        paymentId: paymentId,
        vehicleNumber: String(vNum),
        dateTime: start,
        dateTimeEnd: end,
        amountPaid: amount,
        zone: location,
        type: paymentType,
      });

      // Update vehiclemaster document
      await setDoc(doc(db, "vehiclemaster", String(vNum)), {
        vno: String(vNum),
        location: location,
        pmode: paymentType,
        start: start,
        end: end,
        amountPaid: amount,
        recentid: paymentId
      });

      navigate(`/receipt?vNum=${vNum}`);
    } catch (err) {
      alert('Error saving payment data: ' + err.message);
    }
  };

  return (
    <button
      onClick={handlePayment}
      style={{
        padding: '10px 20px',
        backgroundColor: '#3399cc',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
    >
      Pay ₹{amount} Now
    </button>
  );
};

export default PaymentButton;